// extracted by mini-css-extract-plugin
export var container = "_8j-0";
export var icon = "_8j-1";
export var text = "_8j-2";